import React, { useState } from "react";
import "./styles.css";

const Search = ({ getQuery }) => {
  const [text, setText] = useState("");

  const onChange = (q) => {
    setText(q);
    getQuery(q);
  };

  console.log(text);

  return (
    <section className="search">
      <form>
        <input
          type="text"
          className="form-control mt-5"
          placeholder="Rechercher un Pokémon"
          value={text}
          onChange={(e) => onChange(e.target.value)}
          autoFocus
        />
      </form>
    </section>
  );
};

export default Search;
